import {
  Button as AIMEButton
} from "tot-loft-component-library";

import * as PRTNR from "./prtnr";

import styled from "@emotion/styled";
import { useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import GenericModal from "./GenericModal";
import ModalContactus from "./ModalContactus";
import PhoneInputField from "./prtnr/ui/PhoneInput";
import Footer from "./shared/Footer";
import Navbar from "./shared/Navbar";
import { isValidEmail, isValidPhoneNumber } from "./utils";

export default function Contactus() {
  // Modal logic goes here for Home
  const [isModalOpen, setIsModalOpen] = useState(false);

  
  const [showError, setShowError] = useState(false);
  const [hasSubmitted, setHasSubmitted] = useState(false);


  const [formData, setFormData] = useState({
    first_name: "",
    last_name: "",
    phone_number: "",
    email_address: "",
    message: "",
  });

  const handleChange = (eOrValue, optionalName) => {
    if (typeof eOrValue === "object" && eOrValue.target) {
      const { name, value } = eOrValue.target;
      setFormData({ ...formData, [name]: value });
    } else {
      setFormData({ ...formData, [optionalName]: eOrValue });
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setHasSubmitted(true);
    const { first_name, last_name, phone_number, email_address, message } =
      formData;

    if (
      !first_name ||
      !last_name ||
      !phone_number ||
      !email_address ||
      !message
    ) {
      setShowError(true);

      return;
    } else {
      setShowError(false);
      openModal();
    }

    if (!isValidEmail(email_address)) {
      toast.error("Please enter a valid email address");
      return;
    }

    // const result = await dispatch(
    //   postVendorrecommendation({
    //     first_name,
    //     last_name,
    //     phone_number,
    //     message,
    //   })
    // );

    // if (postVendorrecommendation.fulfilled.match(result)) {
    //   // toast.success("Vendor recommendation submitted!");

    //   setHasSubmitted(false);
    // } else {
    //   setHasSubmitted(false);
    //   toast.error(result.payload || "Submission failed");
    // }
  };

  const openModal = () => setIsModalOpen(true);
  const closeModal = () => setIsModalOpen(false);

  return (
    <RootWrapperContactus>
     
      <Section>
        <Wrapper>
          <ReferAFriend>
            <ContentBlock1>
              <Content>
                <EarningCashForMakingReferralsIsEasierThanEver>
                  Contact Us
                </EarningCashForMakingReferralsIsEasierThanEver>
                <DiscoverPaartnerSTrustedAlliesReadyToHelpYourFriendsWithTheServicesAndMarTechTheyNeedToSucceed>
                  We’re here to help. Fill out the form below and we’ll be in
                  touch asap.
                </DiscoverPaartnerSTrustedAlliesReadyToHelpYourFriendsWithTheServicesAndMarTechTheyNeedToSucceed>
              </Content>
            </ContentBlock1>
            <Frame59 as={"form"} onSubmit={handleSubmit}>
              <InputWrapper>
                <PRTNR.Input
                  label="First Name"
                  name="first_name"
                  value={formData.first_name}
                  onChange={handleChange}
                  required
                  error={hasSubmitted && !formData.first_name}
                  errorMessage={"Required Field"}
                />
                <PRTNR.Input
                  label="Last Name"
                  name="last_name"
                  value={formData.last_name}
                  onChange={(val) => handleChange(val, "phone_number")}
                  required
                  error={hasSubmitted && !formData.last_name}
                  errorMessage={"Required Field"}
                />
              </InputWrapper>
              <PhoneInputField
                label="Phone"
                name={"phone_number"}
                value={formData.phone_number}
                onChange={(val) =>
                  setFormData((prev) => ({ ...prev, phone_number: val }))
                }
                required
                error={
                  hasSubmitted &&
                  (!formData.phone_number ||
                    !isValidPhoneNumber(formData.phone_number))
                }
                errorMessage={
                  !formData.phone_number
                    ? "Required Field"
                    : "Phone number must be 10 to 15 digits"
                }
              />
              <PRTNR.Input
                label="Email Address"
                name={"email_address"}
                value={formData.email_address}
                onChange={handleChange}
                required
                error={hasSubmitted && !formData.email_address}
                errorMessage={"Required Field"}
              />

              <PRTNR.TextArea
                label={"Message"}
                name={"message"}
                value={formData.message}
                onChange={handleChange}
                required
                error={hasSubmitted && !formData.message}
                errorMessage={"Required Field"}
              />
              <Frame59_0001>
                <AIMEButton
                  size="small"
                  onClick={(e) => handleSubmit(e)}
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                    flexDirection: "row",
                    alignItems: "center",
                    flex: "none",
                    gap: "10px",
                    borderRadius: "48px",
                    width: "320px",
                    background: "rgb(33, 37, 67)",
                    backgroundRepeat: "no-repeat",
                    backgroundSize: "contain",
                    backgroundPosition: "center",
                    boxSizing: "border-box",
                    padding: "16px 32px",
                  }}
                >
                  <span
                    style={{
                      color: "white",
                      textOverflow: "ellipsis",
                      fontSize: "16px",
                      fontFamily: "Montserrat, sans-serif",
                      fontWeight: "600",
                      lineHeight: "110%",
                      textAlign: "left",
                    }}
                  >
                    Submit
                  </span>
                </AIMEButton>
              </Frame59_0001>
            </Frame59>
          </ReferAFriend>
        </Wrapper>
      </Section>
      
      <GenericModal isOpen={isModalOpen} onClose={closeModal}>
        <ModalContactus isOpen={isModalOpen} onClose={closeModal} />
      </GenericModal>
    </RootWrapperContactus>
  );
}

const RootWrapperContactus = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: center;
  min-height: 100vh;
  background: rgb(255, 255, 255);
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
  box-sizing: border-box;
  /* padding-top: 98px;
  @media (max-width: 991px) and (min-width: 768px) {
    padding-top: 72px;
  }

  @media (max-width: 767px) {
    padding-top: 72px;
  } */
`;

const Section = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  align-self: stretch;
  background: rgb(241, 245, 249);
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
  box-sizing: border-box;
  padding: 60px;
  flex-shrink: 0;
  @media (max-width: 991px) and (min-width: 768px) {
    padding: 60px 16px;
  }

  @media (max-width: 767px) {
    padding: 60px 16px;
  }
`;

const Wrapper = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  flex: none;
  width: 1200px;
  box-sizing: border-box;
  @media (max-width: 991px) and (min-width: 768px) {
    width: 100%;
  }

  @media (max-width: 767px) {
    width: 100%;
  }
`;

const ReferAFriend = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: center;
  gap: 32px;
  align-self: stretch;
  box-sizing: border-box;
  flex-shrink: 0;
`;

const ContentBlock1 = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: row;
  align-items: center;
  gap: 32px;
  align-self: stretch;
  box-sizing: border-box;
  flex-shrink: 0;
`;

const Content = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: center;
  flex: 1;
  width: 1200px;
  box-sizing: border-box;
  @media (max-width: 991px) and (min-width: 768px) {
    width: 100%;
  }

  @media (max-width: 767px) {
    width: 100%;
  }
`;

const EarningCashForMakingReferralsIsEasierThanEver = styled.span`
  color: rgb(33, 37, 67);
  text-overflow: ellipsis;
  font-size: 48px;
  font-family: Montserrat, sans-serif;
  font-weight: 600;
  letter-spacing: -1px;
  text-align: center;
  align-self: stretch;
  flex-shrink: 0;
  @media (max-width: 991px) and (min-width: 768px) {
    font-size: 24px;
    letter-spacing: -0.48px;
  }

  @media (max-width: 767px) {
    font-size: 24px;
    letter-spacing: -0.48px;
  }
`;

const DiscoverPaartnerSTrustedAlliesReadyToHelpYourFriendsWithTheServicesAndMarTechTheyNeedToSucceed = styled.span`
  color: rgb(33, 37, 67);
  text-overflow: ellipsis;
  font-size: 20px;
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  line-height: 160%;
  text-align: center;
  align-self: stretch;
  flex-shrink: 0;
  @media (max-width: 991px) and (min-width: 768px) {
    font-size: 16px;
  }

  @media (max-width: 767px) {
    font-size: 16px;
  }
`;

const Frame59 = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: center;
  flex: none;
  gap: 16px;
  border: solid 1px rgba(136, 136, 136, 0.1);
  border-radius: 32px;
  width: 960px;
  background: rgb(226, 232, 240);
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
  box-sizing: border-box;
  padding: 32px;
  @media (max-width: 991px) and (min-width: 768px) {
    width: 100%;
    padding: 16px;
  }

  @media (max-width: 767px) {
    width: 100%;
    padding: 16px;
  }
`;
const InputWrapper = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: row;
  align-self: stretch;
  gap: 24px;
  @media (max-width: 991px) and (min-width: 768px) {
    width: 100%;
    flex-direction: column;
  }

  @media (max-width: 767px) {
    width: 100%;
    flex-direction: column;
  }
`;

const Frame59_0001 = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  align-self: stretch;
  box-sizing: border-box;
  flex-shrink: 0;
`;
